import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Lead} from 'src/app/domain/model/lead/lead.model';
import {AppEnvironmentService} from 'src/app/infrastructure/environment/app-environment/app-environment.service';
import {Router} from 'src/app/infrastructure/router/router';
import {Modal} from 'src/app/infrastructure/service/modal.service';
import {WebPage} from 'src/app/ui/webapp/page/web.page';

@Component({
  selector: 'app-confirm-data',
  templateUrl: 'confirm-data.modal.html',
})

export class ConfirmDataModalPage extends WebPage {
  lead: Lead;
  name: string;
  surname: string;
  vat: string;

  constructor(
    router: Router,
    private modalService: Modal,
    appEnvironment: AppEnvironmentService,
    titleService: Title
  ) {
    super(router, appEnvironment, titleService);
  }

  dismiss(): void {
    this.modalService.dismiss(false);
  }

  confirm(): void {
    this.modalService.dismiss(true);
  }
}
